import React from 'react';
import 'katex/dist/katex.min.css';
import { CartProvider } from './src/lib/shop/CartContext';

export const wrapRootElement = ({ element }) => <CartProvider>{element}</CartProvider>;
